module.exports = __webpack_public_path__ + "img/3_95.5d9473b2.png";